import { find, propEq } from 'ramda';
import { z } from 'zod';

import { commonErrors } from '@utils/error';
import { exists } from '@utils/general';
import { requiredString } from '@utils/validation';

import relationships from '@data/relationships';

export const testContent = {};

export const schema = z.object({
	firstName: requiredString(commonErrors.inputRequired),
	lastName: requiredString(commonErrors.inputRequired),
	phone: requiredString(commonErrors.inputRequired),
	relationship: requiredString(commonErrors.selectionRequired).refine(
		(relationship) => exists(find(propEq('value', relationship))(relationships)),
		commonErrors.selectionRequired
	),
	email: z.string().optional(),
});
